export enum ConversationState {
  Pending = 0,
  Active = 1,
  Inactive = 2,
  Closed = 3,
}

export interface ConversationDto {
  id: string;
  twilioSid: string;
  channelType?: string | null;
  state: ConversationState;
  customers?: ConversationCustomerDto[] | null;
  customerPhone?: string | null;
  lastMessageText?: string | null;
  lastMessageAt?: string | null; // Date string ISO
  createdAt: string; // Date string ISO
  operatorId?: string | null;
  operatorName?: string | null;
  teamId?: string | null;
  teamName?: string | null;
  lockedByOperatorId?: string | null;
  lockedByOperatorName?: string | null;
  unreadMessages: number;
  showTransferBadge: boolean;
}

export interface ConversationCustomerDto {
  name: string;
  surname: string;
  code: string;
}

export interface ConversationDtoPagedResult {
  items: ConversationDto[] | null;
  page: number;
  pageSize: number;
  totalCount: number;
  totalPages: number;
}
